import { StringUnionKeyAsValue } from '~src/commonInfra/utils/TypescriptHelpers';

export type RequestAccessType = 'project' | 'view' | 'workbook'| 'datasource' | 'metric' | 'flow' | 'collection' | 'lens' | 'virtualConnection' | 'virtualConnectionTable';

export const RequestAccessTypeValue: StringUnionKeyAsValue<RequestAccessType> = {
  project: 'project',
  workbook: 'workbook',
  view: 'view',
  datasource: 'datasource',
  flow: 'flow',
  metric: 'metric',
  collection: 'collection',
  lens: 'lens',
  virtualConnection: 'virtualConnection',
  virtualConnectionTable: 'virtualConnectionTable'
};
